import React, { useEffect, useState } from 'react';

/**
 * EuropcarSeoRaporu: Europcar Türkiye organik arama performansı sunumu.
 * Route: /r/europcar-organik-arama (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 16 slayt, 16:9, apple.com tasarım dili. Bütün rakamlar Search Console ham
 * tablolarından ve konum sayfası taramasından üretiliyor; kaynak ve yeniden
 * üretim: node src/pages/europcar-seo/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~80KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function EuropcarSeoRaporu() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./europcarSeoDeckHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Europcar Türkiye · Organik Arama Performansı"
      srcDoc={html}
      style={fill}
    />
  );
}
